import { FC, useState, useEffect } from 'react';
import { getFile } from 'src/services/schoolRequest';
import { useLocation } from 'react-router-dom';
import { ErrorNotice, Loader } from 'src/generic/component';

import { DIRequestForm } from './institution/diRequestForm';
import { ISummary } from 'src/types';
import { useAuth } from 'src/contexts';

const READ_ONLY_STATUSES = ['processing', 'opsApproved', 'completed'];
const isReadOnly = (summary: ISummary) => {
  const { processStatus } = summary;
  const cannotResubmit = (processStatus === 'rejected');
  return (READ_ONLY_STATUSES.includes(processStatus) || cannotResubmit);
};

//errror handling assumes initial data is set/entire obj exists
const baseInitial = {
  org: {
    visitingAddress: {
      countryIsoCd: 'US',
    },
  },
  di: {
    apEligibilityInd: false,
    satEligibilityInd: false,
    // clepEligibilityInd: false,
    apContact: {},
    satContact: {},
    // clepContact: {},
  },
  appForm: {
    apElectronicRprt: false,
    // clepElectronicRprt: false,
  },
};

// Retrieve the DI form using the categoryId and userId with a custom hook here...
const useFile = (file: string) => {
  const [data, setData] = useState<any | undefined>(baseInitial);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [errorLoading, setError] = useState<string>('');

  const retrieve = async (file: string) => {
    setLoading(true);
    try {
      const request = await getFile(file);
      if (request) {
        request.data.org = { ...baseInitial.org, ...request?.data?.org };
        request.data.di = { ...baseInitial.di, ...request.data?.di };
        request.data.appForm = { ...baseInitial.appForm, ...request.data?.appForm };
        setData(request);
      } else {
        throw new Error('No s3 file found');
      }

    } catch (error: any) {
      setError(error?.message || error);
    }
    setLoading(false);
  };

  useEffect(() => {
    retrieve(file);
  }, [file]);

  return { data, setData, isLoading, errorLoading };
};

export const DIFormPage: FC = () => {
  const { isAdmin } = useAuth();
  
  const location = useLocation();
  const state = location.state as any;
  const summary = state?.summary as ISummary
  const file = state?.file as string;

  const readOnly = isAdmin || isReadOnly(summary);
  const filePath = file || ((readOnly) ? (summary.submission || summary.draft) : summary.draft);

  const { data, isLoading, errorLoading } = useFile(filePath);
 
  if (isLoading) {
    return <Loader />;
  } else if (errorLoading) {
    return <ErrorNotice errorMessage={errorLoading} />;
  } else if (data) {
    return <DIRequestForm readOnly={readOnly} summary={summary} request={data} />;
  } else {
    return <ErrorNotice errorMessage='No data returned from the server, something went wrong!' />;
  }
};